// Mood wave — one tap a day, drawn as a quiet wave over weeks.
// Shape: { "YYYY-MM-DD": 1..5 } (latest tap of the day wins)
// by David Hunt

const STORAGE_KEY = "stillwater.moodEntries";

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const obj = raw ? JSON.parse(raw) : {};
    return obj && typeof obj === "object" ? obj : {};
  } catch (_) {
    return {};
  }
};

export const todayKey = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const recordMood = (value) => {
  const entries = load();
  entries[todayKey()] = value;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch (_) {
    /* silent */
  }
};

export const getTodayMood = () => load()[todayKey()] ?? null;

// Last `days` days as [{ key, value|null }], oldest first.
export const getRecentMoods = (days = 28) => {
  const entries = load();
  const out = [];
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const key = todayKey(d);
    out.push({ key, value: entries[key] ?? null });
  }
  return out;
};

// Smooth SVG path through the recorded points (nulls skipped).
export const buildWavePath = (moods, width, height, pad = 10) => {
  const pts = moods
    .map((m, i) => ({ i, value: m.value }))
    .filter((p) => p.value != null)
    .map((p) => ({
      x: pad + (p.i / Math.max(moods.length - 1, 1)) * (width - pad * 2),
      y: pad + ((5 - p.value) / 4) * (height - pad * 2),
    }));
  if (pts.length === 0) return { path: "", points: [] };
  if (pts.length === 1)
    return { path: `M ${pts[0].x} ${pts[0].y}`, points: pts };
  let d = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 1; i < pts.length; i++) {
    const prev = pts[i - 1];
    const cur = pts[i];
    const mx = (prev.x + cur.x) / 2;
    d += ` C ${mx} ${prev.y}, ${mx} ${cur.y}, ${cur.x} ${cur.y}`;
  }
  return { path: d, points: pts };
};
